import "./HomeIndexBrand.css"

interface HomeIndexBrandProps {
    asLink?: boolean
}

export default function HomeIndexBrand({ asLink = false }: HomeIndexBrandProps) {
    const content = (
        <>
            <img src="/homeindex_logo.svg" alt="" className="homeindex-brand-logo" aria-hidden />
            <span className="homeindex-brand-text">HomeIndex</span>
        </>
    )
    if (asLink) {
        return <a href="/" className="homeindex-brand" aria-label="HomeIndex – Home">{content}</a>
    }
    return <span className="homeindex-brand" role="img" aria-label="HomeIndex">{content}</span>
}
